import { ButtonFillMode as KedoButtonFillMode, ButtonRounded as KendoButtonRounded, ButtonSize as KendoButtonSize,  ButtonThemeColor as KendoButtonThemeColor} from "@progress/kendo-angular-buttons";
export declare type ButtonThemeColor = KendoButtonThemeColor;
export declare type ButtonRounded = KendoButtonRounded;
export declare type ButtonSize = KendoButtonSize;
export declare type ButtonFillMode = KedoButtonFillMode;




